import React, {createElement, useEffect, useState, useMemo} from 'react';
import axios from '../Common/axios';
import { useParams } from 'react-router-dom';
import {Tabs, Button, Layout, Spin, Modal} from "antd";
import Summary from './Summary';
import Item from './Item';
import ItemNew from './ItemNew';
import Compare from './Compare';
import ReportHeader from '../Common/ReportHeader';
import {getFindVulnerablityStatistics, getPdfDownload} from '../Common/api';
import DownloadUrl from '../../components/DownloadUrl';
import {DownloadMd} from '../../components/DownloadPdf';
import MarkdownViewer from '../../components/MarkdownViewer';

const {Content } = Layout;
const {TabPane} = Tabs;

function Vulnerablity() {
    const params = useParams();
    const loadDefaultMessage = "Loading...";
    const [loadMessage, setLoadMessage] = useState(loadDefaultMessage);

    // 변수 선언
    const reportId = params.reportId;
    const [companyCode, setCompanyCode] = useState('');
    const [assetType, setAssetType] = useState('');
    const [reportName, setReportName] = useState('');
    const reportType = 'C';  //최초분석
    const [tabId, setTabId] = useState('1');
    const [reportInfo, setReportInfo] = useState({});
    const [spinflag, setSpinflag] = useState(true);
    const [spinflagMain,  setSpinflagMain] = useState(false);
    const [markdownVisible, setMarkdownVisible] = useState(false);
    const [markdownContent, setMarkdownContent] = useState('');

    useEffect(() => {
        if(reportInfo) {
            setCompanyCode(reportInfo.com_cd);
            setAssetType(reportInfo.asset_type);
            setReportName(reportInfo.report_nm);
        }
    }, [reportInfo]);

    const [itemList, setItemList ] = useState([]);
    const [measureList, setMeasureList] = useState([]);
    const [assetList, setAssetList] = useState([]);
    const [assetSum, setAssetSum] = useState([]);

    const [sumData, setSumData] = useState({total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0});

    useEffect(() => {
        findReportList(reportId);
    }, [reportId]);

    useEffect(() => {
        let s_data = {total : 0, check : 0, Y : 0, Yed : 0, N : 0, P : 0, NA : 0, total_score : 0, eval_score : 0, level : 0};
        measureList.map(curr => {
            s_data.total = s_data.total + curr.total;
            s_data.check = s_data.check + curr.check;
            s_data.Y = s_data.Y + curr.Y;
            s_data.Yed = s_data.Yed + curr.Yed;
            s_data.N = s_data.N + curr.N;
            s_data.P = s_data.P + curr.P;
            s_data.NA = s_data.NA + curr.NA;
            s_data.total_score = s_data.total_score + curr.total_score;
            s_data.eval_score = s_data.eval_score + curr.eval_score;
            return s_data;
        });
        s_data.level = (s_data.eval_score /  s_data.total_score) * 100;
        setSumData(s_data);
      }, [measureList]);

    useEffect(() => {
        let s_data = [];
        assetList.map(curr => {
            // s_data.push({'asset_cd': curr.code, 'sum': curr.Y + curr.Yed });
            s_data.push({'asset_cd': curr.code, 'sum': curr.Y});
            return s_data;
        });

        setAssetSum(s_data);

    }, [assetList]);


    // 레포트 조회
    const findReportList = (reportId) => {
        if(reportId) {
            //통계 조회
            axios.get(getFindVulnerablityStatistics(reportId, reportType))
                .then((response) => {
                    //console.log(response);
                    // setItemList(response.data.statistic_root);
                    setItemList(response.data.statistic_root.sort((a, b) => 
                        a.measure_type.localeCompare(b.measure_type)
                    ));
                    setMeasureList(response.data.statistic_measure);
                    setAssetList(response.data.statistic_asset);               
                })
                .catch((error) => {
                    console.log("Vulnerablity.js ------- 90 에러");
                    console.dir(error);
                })
                .finally(() => {
                    setSpinflag(false);
                });
        }
    }
    // 다운로드
    // 닫기
    const onClickCloseHandler = () => {
        window.close();
    }

    // 탭클릭
    const onChangeTabHandler = (key) => {
        //console.log(key);
        setTabId(key);
    };

    const items = [
        {
          key: '1',
          label: '요약 및 그래프',
          children: <Summary assetType={assetType} measureList={measureList} assetList={assetList} sumData={sumData} spinflag={spinflag} />,
        },
        {
          key: '2',
          label: '항목별 통계',
          children: <ItemNew itemList={itemList} sumData={sumData} assetSum={assetSum} />,
        },
        {
          key: '3',
        //   label: '발행년도 통계'력
          label: '취약점 점검 이력',
          children: <Compare itemList={itemList} sumData={sumData} companyCode={companyCode} assetType={assetType} reportId={reportId} reportName={reportName} />,
        },
    ];
    
    //PDF다운로드
    const pdfDownload00 = () => {
        let opt = {
            margin:       5,
            filename:     'myfile2.pdf',
            image:        { type: 'jpeg', quality: 0.98 },
            html2canvas:  { scale:  1.8 },
            jsPDF:        { unit: 'px', format: 'a1', orientation: 'p' },
            // pagebreak: { mode: 'avoid-all', before: '#page2el' },
          };
        
        const report = document.getElementById('report');
        html2pdf().from(report).set(opt).save();
    };

    const pdfDownload01 = () => {
        let jsPdf = new jsPDF('p', 'mm', 'a4');
        var htmlElement = document.getElementById('report');
        // you need to load html2canvas (and dompurify if you pass a string to html)
        const opt = {
            callback: function (jsPdf) {
                jsPdf.save("Test.pdf");
                // to open the generated PDF in browser window
                // window.open(jsPdf.output('bloburl'));
            },
            dpi:100,
            windowWidth:200,
            margin: [5, 5, 5, 5],
            autoPaging: 'text',
            width:200,
        };
    
        jsPdf.html(htmlElement, opt);
    };

    const pdfDownload = () => {

        const report = document.getElementById('report');
        const data = document.getElementById('divTabs' + tabId);
        const div_height = data.style.height;
        data.style.height = (data.scrollHeight) + 'px';

        DownloadPdf(report, reportId,'p');
        // html2canvas(report,{ scale: 1.8 }).then((canvas) => {
        //     const marginLeft = 3; // 출력 페이지 여백설정
        //     const marginTop = 3;
        //     const imgWidth = 204;  // 208
        //     const pageHeight = 290;

        //     // const imgHeight = (canvas.height * imgWidth) / canvas.width;
        //     const m = imgWidth/canvas.width;
        //     const imgHeight = canvas.height * m;
        //     const imgPageHeight = Math.round(pageHeight / m)-10;

        //     console.log(m+":"+imgPageHeight);
        //     let heightLeft = imgHeight;
        //     let position = marginTop;
        //     let imageClip="";

        //     heightLeft -= pageHeight;

        //     const doc = new jsPDF('p', 'mm', 'a4');
        //     console.dir(canvas);
            
        //     imageClip = getClipImage(canvas,0,0, canvas.width, imgPageHeight, m);
        //     doc.addImage(imageClip, 'jpeg', marginLeft , marginTop, imgWidth, pageHeight, '', 'SLOW');
        //     // const imgData = canvas.toDataURL('image/jpeg'); 
        //     // doc.addImage(imageClip, 'jpeg', margin, position, imgWidth, imgHeight, '', 'FAST');

        //     while (heightLeft >= 0) {
        //         position = heightLeft - imgHeight;
        //         doc.addPage();
        //         imageClip = getClipImage(canvas, 0, imgPageHeight, canvas.width, imgPageHeight, m);
        //         doc.addImage(imageClip, 'jpeg', marginLeft , marginTop, imgWidth, pageHeight, '', 'SLOW');
        //         heightLeft -= pageHeight;
        //     }

        //     doc.save('Vulnerablity_'+reportId+'.pdf');
        //     doc.close();
        // });
        // //높이 재조정
        data.style.height = div_height;
    };

    const pdfDownLoadReport = (event) =>{
        setSpinflagMain(true);
        setLoadMessage("잠시만 기다려 주세요. 보고서 작성중 입니다...");
        let titleName="보고서 생성";
        
        const buttonType = event.currentTarget.textContent;

        if (buttonType === 'Markdown') {
            axios.get(getPdfDownload("vul_md", reportId)).then((response) => {
                setMarkdownContent(response.data);
                setMarkdownVisible(true);
                setSpinflagMain(false);
            }).catch((error) => {
                Modal.error({title:titleName,content:"Markdown 생성 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        }else{
            axios.get(getPdfDownload("vul", reportId)).then((response) => {
                
                if(response.data.status_url){
                    DownloadUrl(response.data.status_url,
                        () => setSpinflagMain(false), // onSuccess  
                        (errorMessage) => {
                            Modal.error({title:titleName, content:errorMessage, okText:"Close"});
                            setSpinflagMain(false);
                        }
                    );
                }else{
                    Modal.error({title:titleName, content:"다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                    setSpinflagMain(false);
                }
            }).catch((error) => {
                Modal.error({title:titleName, content:"다운로드 중에 에러가 발생하였습니다.", okText:"Close"});
                setSpinflagMain(false);
            });  
        }  
    }

    // const  getClipImage= (image, x, y, width, height, m)=>{

    //     let canvas = document.createElement('canvas');
    //     let ctx = canvas.getContext('2d');

    //     canvas.width = width;
    //     canvas.height = height;
    //     ctx.fillStyle = "#ffffff";
    //     ctx.fillRect(0,0, width, height);
    
    //     ctx.drawImage(image, x, y, width, height,  0, 0, width, height);
    
    //     return canvas;
    // }

    return (
        <Spin size={"large"}  tip={loadMessage} spinning={spinflagMain}>
        <Layout id="report" style={{overflow: 'hidden'}}>
            <div className='popup_header'>
                <div className='popup_title'>
                    취약점진단 : 통계
                </div>
            </div>
            <div className="popup_button_report" style={{top:'10px'}}>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'Markdown'}
                </Button>
                <Button
                        type="default"
                        onClick={pdfDownLoadReport}
                        style={{marginLeft: '10px'}}
                        data-html2canvas-ignore="true"
                    >
                        {'보고서'}
                </Button>
                <Button
                    type="default"
                    onClick={onClickCloseHandler}
                    style={{marginLeft: '10px'}}
                    data-html2canvas-ignore="true"
                >
                    {'닫기'}
                </Button>
            </div>
            <div className="section" id="reportHeader">
                <ReportHeader reportId={reportId} reportInfo={reportInfo} setReportInfo={setReportInfo}/>
            </div>
            <div className="section" style={{borderTop: '0'}}>
                 <Content style={{ backgroundColor: '#f5f5f5'}}>
                    <Tabs defaultActiveKey="1" type={'card'} onChange={onChangeTabHandler} items={items}></Tabs>
                </Content>
            </div>
        </Layout>
        <MarkdownViewer 
            visible={markdownVisible}
            onClose={() => setMarkdownVisible(false)}
            markdownContent={markdownContent}
            reportId={reportId}
            reportName={reportName}
        />
        </Spin>
    );
}

export default Vulnerablity;